// extracted by mini-css-extract-plugin
export default {"calendar-body":"Calendar_calendar-body__SQBw2","days":"Calendar_days__KYVYD","day":"Calendar_day__SWX1k"};